export const SHOW_MODAL = 'MODAL/SHOW';
export const HIDE_MODAL = 'MODAL/HIDE';
